import { IBranchValidation, TEditableBranch } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';
import { defaulLangTextValidation, PAYMENT_TYPES } from 'src/constants/main';
import { DELIVERY_TYPE_PICKER_OPTION } from 'src/constants/deliveryTypes';
import { defaultCoordinates } from 'src/constants/map';

export const defaultEditableBranch: TEditableBranch = {
  name: {
    en: '',
    ar: '',
  },
  phone: '',
  external_id: '',
  address: '',
  latitude: defaultCoordinates.lat,
  longitude: defaultCoordinates.lng,
  status: 0,
  preorder: 0,
  is_emenu: false,
  is_curbside: 0,
  pre_select_default: false,
  allow_all_payment_methods: 0,
  is_max_cash_payment: 0,
  working_time: [],
  delivery_fee_type: 0,
  min_order_type: 0,
  reduced_delivery_fee_type: 0,
  delivery_fee: 0,
  min_order: 0,
  areas: [],
  reduced: [
    {
      id: null,
      delivery_fee: '0',
      order_more_than: '0',
    },
  ],
};

export const defaultBranchPaymentTypes = [
  { id: PAYMENT_TYPES.CASH, type: 'cash', status: true },
  { id: PAYMENT_TYPES.ONLINE_PAYMENT, type: 'txt_credit_cart', status: false },
  { id: PAYMENT_TYPES.TERMINAL, type: 'terminal', status: false },
];

export const defaultBranchDineInPaymentTypes = [
  { id: PAYMENT_TYPES.CASH, type: 'cash', status: true },
  { id: PAYMENT_TYPES.ONLINE_PAYMENT, type: 'txt_credit_cart', status: false },
  { id: PAYMENT_TYPES.TERMINAL, type: 'terminal', status: false },
];

export const defaultBranchOrderTypes = [
  { id: DELIVERY_TYPE_PICKER_OPTION.DELIVERY, type: 'delivery', status: true },
  { id: DELIVERY_TYPE_PICKER_OPTION.PICKUP, type: 'txt_pickup', status: false },
  { id: DELIVERY_TYPE_PICKER_OPTION.CURBSIDE, type: 'curbside', status: false },
  { id: DELIVERY_TYPE_PICKER_OPTION.DINE_IN, type: 'dine_in', status: false },
];

export const defaultBranchValidation: IBranchValidation = {
  details: {
    name: defaulLangTextValidation,
    phone: { isValid: true, errorText: '' },
    address: true,
    paymentTypes: true,
    orderTypes: true,
  },
  deliverySettings: {
    reduced: {
      areaID: [],
      delivery_fee: true,
    },
  },
  dineIn: {
    paymentTypes: true,
  },
};

export enum BRANCH_EDIT_TAB {
  DETAILS,
  DELIVERY_SETTINGS,
  DINE_IN,
}
